import { Chip, IconPath } from '@nespresso-design-system/components'
import styles from './ChipsCategories.module.scss'
import { selectPromotion } from '@content/helpers/src/gtmEvents.js'
import { CampaignProps } from '@commons/drupal.types'

type Category = {
    id: string
    label: string
    icon?: IconPath
}

type ChipsCategoriesProps = {
    campaign: CampaignProps
    categories: Category[]
    categoryCallback: (id: string | number) => void
    activeCategory: string
}
const ChipsCategories = ({
    campaign,
    categories,
    categoryCallback,
    activeCategory
}: ChipsCategoriesProps) => {
    if (categories.length === 1) {
        return null
    }

    const handleChip = (id: string, label: string, index: number) => {
        categoryCallback(id)

        selectPromotion({
            ...campaign,
            cta_name: `chips click - ${index + 1} - ${label}`
        })
    }

    return (
        <ul className={styles.categories}>
            {categories.map((category, index) => (
                <li key={category.id}>
                    <Chip
                        {...category}
                        icon={category.icon}
                        onClick={() =>
                            handleChip(category.id, category.label, index)
                        }
                        isActive={category.id === activeCategory}
                        isSelected={category.id === activeCategory}
                        role="tab"
                        aria-selected={category.id === activeCategory}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ')
                                handleChip(category.id, category.label, index)
                        }}
                    />
                </li>
            ))}
        </ul>
    )
}

export default ChipsCategories
